module.exports = __webpack_public_path__ + "static/img/girl.fd7add0a.png";